export default "__VITE_ASSET__ee48b85c__"